import React from 'react'
import parkingLocationPagesDE from '../../../../config/parkingLocationPagesDE'
import ProductSelect from './productSelect.jsx'

const ParkingSelect = ({id, label = 'Flughafen auswählen'}) => (
  <ProductSelect id={id} label={label} options={parkingLocationPagesDE} />
)

export default ParkingSelect



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/dropdowns/parkingselectDE.jsx